var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:(_vm.showContact),attrs:{"title":_vm.name,"aria-label":_vm.name,"type":"button"},on:{"click":function($event){return _vm.selectContact(_vm.name)}}},[_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }